import axios from 'axios'
// state
const state = {
    shop: {
        show: 0,
        storeName: '',
        storeUrl: '',
        storeUrlEncode: '',
        storeImg: '',
        storeBackImg: '',
        storeAddPrice: '',
        allowRegist: false,
        nickName: '',
        mobile: ''
    },
    lineInputTitle: '',
    isMarketing: '' // 是否开通营销版开通：1，未开通0
}

// getters
const getters = {
    shop: state => state.shop,
    lineInputTitle: state => state.lineInputTitle,
    isMarketing: state => state.isMarketing
}

// actions
const actions = {
    isShopVip ({ commit, state }, val) {
        axios.get(`/sys/main?xwl=346OCGL1KTXW&erpId=${val.erpId}&appId=${val.appId}`
        ).then(res => {
            if (res.status === 200) {
                commit('initIsMarketing', res.data.isMarketing)
            }
        })
    }
}

// mutations
const mutations = {
    initIsMarketing (state, val) {
        state.isMarketing = val
    },
    setShop (state, val) {
        for (const key in val) {
            if (val.hasOwnProperty(key) && state.shop[key] !== undefined) {
                if (key === 'allowRegist' && val[key] === 0) {
                    val[key] = false
                } else if (key === 'allowRegist' && val[key] === 1) {
                    val[key] = true
                }
                state.shop[key] = val[key]
            }
        }
    },
    isShowShop (state, val) {
        state.shop.show = val
    },
    updateShop (state, obj) {
        state.shop[obj.key] = obj.val
    },
    setlineInputTitle (state, val) {
        state.lineInputTitle = val
    }

}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/shop.js